import { formatCurrency } from '../lib/format';

interface BigNumberProps {
  /** Positive = refund (green). Negative = owed (red). Zero = neutral. */
  amount: number;
  /** Label rendered above the amount. */
  label: string;
  /** Optional secondary line (e.g. effective rate). */
  sublabel?: string;
}

/**
 * Large headline number. Refunds (positive) render in emerald, amounts
 * owed (negative) render in rose. Zero renders in slate. Amount is shown
 * with a leading sign so the meaning reads even without color.
 */
export function BigNumber({ amount, label, sublabel }: BigNumberProps) {
  const tone =
    amount > 0
      ? 'text-emerald-600'
      : amount < 0
      ? 'text-rose-600'
      : 'text-slate-900';

  const sign = amount > 0 ? '+' : amount < 0 ? '-' : '';
  const absAmount = Math.abs(amount);

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-6 text-center">
      <p className="text-sm uppercase tracking-wide text-slate-500">{label}</p>
      <p
        className={`mt-2 font-mono text-5xl font-bold tabular-nums sm:text-6xl ${tone}`}
        aria-live="polite"
      >
        {sign}
        {formatCurrency(absAmount)}
      </p>
      {sublabel ? (
        <p className="mt-3 text-sm text-slate-500">{sublabel}</p>
      ) : null}
    </div>
  );
}